module.exports = __webpack_public_path__ + "static/media/1.4af6e882.png";